import { IPost } from '@sdk/contracts';
import { create as createStore } from 'zustand';

interface IStore {
  post?: IPost;
  isOpen: boolean;
  setPost: (post?: IPost) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const usePostForm = createStore<IStore>(set => ({
  isOpen: false,
  setPost: (post?: IPost) => set({ post }),
  setIsOpen: (isOpen: boolean) => set({ isOpen })
}));
